var map = {
	"./footer.blocks/@TEMPLATE/Settings": [
		244,
		93
	],
	"./footer.blocks/FOOTER_Nav_Simple/Settings": [
		246,
		0,
		1,
		80
	],
	"./header.blocks/@TEMPLATE/Settings": [
		248,
		95
	],
	"./header.blocks/HEADER_Nav_Simple/Settings": [
		249,
		0,
		1,
		85,
		83
	],
	"./page.blocks/@TEMPLATE/Settings": [
		86,
		29
	],
	"./page.blocks/COVER_001/Settings": [
		87,
		0,
		1,
		3,
		30
	],
	"./page.blocks/DOCS_PREVIEW_001/Settings": [
		88,
		0,
		1,
		8,
		26,
		17
	],
	"./page.blocks/Filter_001/Settings": [
		89,
		0,
		1,
		3,
		8,
		24
	],
	"./page.blocks/MENU_001/Settings": [
		90,
		0,
		1,
		22,
		23
	],
	"./page.blocks/SHOPPING_CALL_001_Block/Settings": [
		84,
		0,
		1,
		25
	],
	"./page.blocks/SPACER_001/Settings": [
		91,
		0,
		1,
		3,
		20
	],
	"./page.blocks/Search_001/Settings": [
		92,
		0,
		1,
		3,
		21
	],
	"./page.blocks/TEXT_AND_IMAGE_001/Settings": [
		94,
		16
	],
	"./page.blocks/TEXT_AND_IMAGE_002/Settings": [
		95,
		18
	],
	"./page.blocks/TWITTER_001/Settings": [
		96,
		0,
		1,
		3,
		32
	],
	"./page.blocks/Table_001/Settings": [
		97,
		0,
		1,
		19,
		27
	],
	"./page.blocks/YOUTUBE_001/Settings": [
		98,
		0,
		1,
		3,
		33
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 978;
module.exports = webpackAsyncContext;